<div *ngIf="relatedProfileSettings?.OrgName?.Visible">
  <label class="control-label">{{ relatedProfileSettings.OrgName.LabelText }}</label>
  <input disabled type="text" class="form-control" />
</div>

<div *ngIf="relatedProfileSettings.FirstName.Visible">
  <label class="control-label">{{ relatedProfileSettings.FirstName.LabelText }}</label>
  <input disabled type="text" class="form-control" />
</div>

<div *ngIf="relatedProfileSettings.LastName.Visible">
  <label class="control-label">{{ relatedProfileSettings.LastName.LabelText }}</label>
  <input disabled type="text" class="form-control" />
</div>

<div *ngIf="relatedProfileSettings.MiddleInitial.Visible">
  <label class="control-label">{{ relatedProfileSettings.MiddleInitial.LabelText }}</label>
  <input disabled type="text" class="form-control" />
</div>

<div *ngIf="relatedProfileSettings.Prefix.Visible">
  <label class="control-label">{{ relatedProfileSettings.Prefix.LabelText }}</label>
  <input disabled type="text" class="form-control" />
</div>

<div *ngIf="relatedProfileSettings.Suffix.Visible">
  <label class="control-label">{{ relatedProfileSettings.Suffix.LabelText }}</label>
  <input disabled type="text" class="form-control" />
</div>

<div *ngIf="relatedProfileSettings.Title.Visible">
  <label class="control-label">{{ relatedProfileSettings.Title.LabelText }}</label>
  <input disabled type="text" class="form-control" />
</div>

<div *ngIf="relatedProfileSettings.Address1.Visible">
  <label class="control-label">{{ relatedProfileSettings.Address1.LabelText }}</label>
  <input disabled type="text" class="form-control" />
</div>

<div *ngIf="relatedProfileSettings.Address2.Visible">
  <label class="control-label">{{ relatedProfileSettings.Address2.LabelText }}</label>
  <input disabled type="text" class="form-control" />
</div>

<div *ngIf="relatedProfileSettings.City.Visible">
  <label class="control-label">{{ relatedProfileSettings.City.LabelText }}</label>
  <input disabled type="text" class="form-control" />
</div>

<div *ngIf="relatedProfileSettings.State.Visible">
  <label class="control-label">{{ relatedProfileSettings.State.LabelText }}</label>
  <input disabled type="text" class="form-control" />
</div>

<div *ngIf="relatedProfileSettings.Zip.Visible">
  <label class="control-label">{{ relatedProfileSettings.Zip.LabelText }}</label>
  <input disabled type="text" class="form-control" />
</div>

<div *ngIf="relatedProfileSettings.ZipExt.Visible">
  <label class="control-label">{{ relatedProfileSettings.ZipExt.LabelText }}</label>
  <input disabled type="text" class="form-control" />
</div>

<div *ngIf="relatedProfileSettings.County.Visible">
  <label class="control-label">{{ relatedProfileSettings.County.LabelText }}</label>
  <input disabled type="text" class="form-control" />
</div>

<div *ngIf="relatedProfileSettings.Country.Visible">
  <label class="control-label">{{ relatedProfileSettings.Country.LabelText }}</label>
  <input disabled type="text" class="form-control" />
</div>

<div *ngIf="relatedProfileSettings.WorkPhone.Visible">
  <label class="control-label">{{ relatedProfileSettings.WorkPhone.LabelText }}</label>
  <input disabled type="text" class="form-control" />
</div>

<div *ngIf="relatedProfileSettings.HomePhone.Visible">
  <label class="control-label">{{ relatedProfileSettings.HomePhone.LabelText }}</label>
  <input disabled type="text" class="form-control" />
</div>

<div *ngIf="relatedProfileSettings.CellPhone.Visible">
  <label class="control-label">{{ relatedProfileSettings.CellPhone.LabelText }}</label>
  <input disabled type="text" class="form-control" />
</div>

<div *ngIf="relatedProfileSettings.Ext.Visible">
  <label class="control-label">{{ relatedProfileSettings.Ext.LabelText }}</label>
  <input disabled type="text" class="form-control" />
</div>

<div *ngIf="relatedProfileSettings.Fax.Visible">
  <label class="control-label">{{ relatedProfileSettings.Fax.LabelText }}</label>
  <input disabled type="text" class="form-control" />
</div>

<div *ngIf="relatedProfileSettings.Email.Visible">
  <label class="control-label">{{ relatedProfileSettings.Email.LabelText }}</label>
  <input disabled type="text" class="form-control" />
</div>

<div *ngIf="relatedProfileSettings.RelationTypeToMember?.Visible">
  <label class="control-label">{{ relatedProfileSettings.RelationTypeToMember.LabelText }}</label>
  <input disabled type="text" class="form-control" />
</div>
